import { type HistoryGroup } from "@/features/history/utils";
import { type History } from "@repo/api";
import { Text } from "@repo/skapa";
import { t } from "@repo/translation";
import isEmpty from "lodash/isEmpty";

import { HistoryListViewItem } from "./HistoryListViewItem";

interface Props {
  history: History | HistoryGroup;
}

export const CommunicationHistoryItem = ({ history }: Props) => {
  return (
    <HistoryListViewItem
      history={history}
      control="default"
      title={history.title}
      description={
        <div>
          {history.body && <Text textStyle="Body.S">{history.body}</Text>}
          {!isEmpty(history.details?.order_number) && (
            <Text textStyle="Body.S">{`${t("label.order_id")}: ${
              history.details?.order_number
            }`}</Text>
          )}
          {history.details?.error_message && (
            <Text textStyle="Body.S">{history.details.error_message}</Text>
          )}
        </div>
      }
    />
  );
};
